module.exports = __webpack_public_path__ + "img/家政服务.10f8502a.png";